/*
 *   File : configure-push-notification.js
 *   Author : https://evoqins.com
 *   Description :  Configure push notification
 *   Integrations : react-toastify
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useRef, useState } from 'react';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Modal } from 'bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';


// Custom components 
import { CustomTextInput, CustomFileUpload, TextArea, CustomTimePicker, CustomDatePicker } from '../../../../Component/FormElements';
import { PrimaryButton, TextButton } from '../../../../Component/Buttons';
import { Loader, OverLay } from '../../../../Component/Others';
import { Icon } from '../../../../Component/Icon';
import { APIService, AWSService } from '../../../../Service';
import { ScheduledNotifications } from '../../../../Component/Cards';
import { EmptyScreen } from '../../../../Component/EmptyComponent';
import { Pagination } from '../../../../Component/pagination';
import { ResendPushNotification } from '../../../../Component/Modal';

// Style
import styles from "../../../../Style/Component/notification.module.scss";
import Overlay from '../../../../Component/Others/overlay';

const TAB = [
    {
        id: 1,
        label: "Send push notification",
    },
    {
        id: 2,
        label: "Schedule push notification",
    },
];

const REPEAT_TAB = [
    {
        id: 1,
        name: "Weekly"
    },
    {
        id: 2,
        name: "Monthly"
    },
    {
        id: 3,
        name: "Yearly"
    },
];

const ITEMS_PER_PAGE = 20;

const ConfigurePushNotification = (props) => {

    const { state } = useLocation();
    const navigate = useNavigate()

    const cardRef = useRef(null);

    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedDayError, setSelectedDayError] = useState("");
    const [dateToggle, setDateToggle] = useState(false);
    const [notificationHistoryData, setNotificationHistoryData] = useState({});
    const [loading, setLoading] = useState(true);

    const [totalPageCount, setTotalPageCount] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);

    // Modal state
    const [showResendNotificationModal, setShowResendNotificationModal] = useState(false);
    const [resendNotificationData, setResendNotificationData] = useState("");

    const [toggleFilter, setToggleFilter] = useState(false);
    const [clearFilter, setClearFilter] = useState(false);


    useEffect(() => {
        _pushNotificationHistory();
    }, [currentPage, state?.reload, clearFilter]);

    useEffect(() => {

        window.scrollTo({
            top: 0, behavior: 'smooth' //scroll top
        });

    }, []);


    useEffect(() => {
        if (showResendNotificationModal) {
            const resend_push = new Modal(document.getElementById('resend-push-notification-modal'));
            resend_push.show();
        }
    }, [showResendNotificationModal]);


    //handle pagination
    const _handlePagination = (new_start_limit) => {
        const selected_page = Math.floor(new_start_limit / ITEMS_PER_PAGE) + 1;
        setCurrentPage(selected_page);

        if (cardRef.current) {
            cardRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };


    const _handleClearAll = () => {
        setClearFilter(true);
        setSelectedDay(null);
        setLoading(true);
        setCurrentPage(1);
    };

    //API - Get push notification history
    const _pushNotificationHistory = (page_num = currentPage) => {
        let is_post = true;
        let url = 'CA/notifications/push-notifications';
        let data = {
            "page_num": page_num,
            "date": selectedDay !== null ? format(selectedDay, 'yyyy-MM-dd') : null
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setNotificationHistoryData(response.data);
                setTotalPageCount(Math.ceil(response.data.total_entries / ITEMS_PER_PAGE));
            } else { }
            setLoading(false);

            navigate("/manage-notification", {
                state: {
                    ...state,
                    reload: false
                }
            });

            setClearFilter(false);
        });
    };

    return (
        <div className='row'>
            {/* <div className='col-xl-6 col-lg-7 col-md-8 col-sm-12 col-12'>
                <div className='e-border-1px-platinum-light py-4 ps-4 e-bg-white e-admin-box-shadow e-border-radius-16'>
                    <div className='overflow-auto pb-xl-0 pb-lg-0 pb-md-0 pb-1'>
                        <div className='d-flex gap-0-20px w-max-content'>
                            {TAB.map((data, key) => (
                                <p key={key} className={`${tabIndex === data.id ? `e-text-lust cursor-default e-border-bottom-2px-lust` : `e-text-raisin-black cursor-pointer`}  e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-28px mb-0`}
                                    onClick={() => _handleTabChange(data.id)} >
                                    {data.label}
                                </p>
                            ))}
                        </div>
                    </div>

                    {tabIndex === 1 ?
                        <div className='pt-3 pe-3'>
                            <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                Send push notification
                            </p>

                            <div className='pt-3 pe-2'>
                                <CustomTextInput label="Title"
                                    placeholder="Notification title"
                                    type="text"
                                    require
                                    value={title}
                                    error={titleError}
                                    className="w-100"
                                    labelStyle="e-font-weight-500 e-text-raisin-black"
                                    handleChange={(e) => setTitle(e)} />

                                <TextArea label="Content"
                                    placeholder="Enter your text..."
                                    type="text"
                                    rows="3"
                                    require
                                    value={content}
                                    error={contentError}
                                    className=" px-3 padding-12px-tb w-100"
                                    handleChange={(e) => setContent(e)} />

                                <div >
                                    <CustomFileUpload label="Upload image"
                                        placeholder="Drop your image here"
                                        require
                                        file={image}
                                        fileType={["JPG", "PNG", "JPEG"]}
                                        resolution="328px * 150px"
                                        requiredWidth={328}
                                        requiredHeight={150}
                                        errorUpdate={errorUpdate}
                                        error={imageError}
                                        loader={imageLoader}
                                        handleChange={_uploadedImage} />

                                    {image !== null &&
                                        <div className='mb-2 margin-neg-20px-top'>
                                            <TextButton name="Change image"
                                                onPress={_handleChangeImage} />
                                        </div>
                                    }
                                </div>
                                <div className='pt-4 '>
                                    <PrimaryButton name="Send now"
                                        className="w-100"
                                        status={sendCreateLoader}
                                        onPress={_handleSendPushNotification} />
                                </div>
                            </div>
                        </div>
                        :
                        <div className='pt-3 pe-2'>
                            <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                Scheduled notifications
                            </p>

                            <div className={`${styles.e_schedule} ${showTimePicker ? 'overflow-hidden' : 'overflow-y-auto'} pt-3 pe-3 h-358px  overflow-x-hidden`}>
                                <p className='mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                    Pick start date<span className='e-text-lust'>*</span>
                                </p>
                                <div className='pt-2 row'>
                                    <div ref={(ref) => errorRef.current['date'] = ref} className='col-5 '>
                                        <div className='position-relative h-60px'>
                                            <div className={`${dateToggle ? 'e-border-1px-indigo' : 'e-border-1px-platinum-light'} e-display-flex gap-0-4px e-border-radius-6 padding-14px-tb px-2 cursor-pointer`}
                                                onClick={_handleDateToggle}>
                                                <img src={require("../../../../Assets/Image/CountryAdmin/Notification/calendar-icon.svg").default}
                                                    draggable={false}
                                                    alt='calender-icon' />
                                                {selectedDay !== null ?
                                                    <p className='mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-16px'>
                                                        {format(selectedDay, 'PP')}
                                                    </p>
                                                    :
                                                    <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-16px'>
                                                        Choose date
                                                    </p>
                                                }
                                            </div>

                                            <p className='mb-0 e-error-message e-alt-font-noto-sans e-font-12 line-height-12px padding-2-top'>
                                                {selectedDayError}
                                            </p>

                                            {selectedDay !== null &&
                                                <Icon icon="close-icon"
                                                    className='position-absolute top-14px right-8px cursor-pointer'
                                                    size="20px"
                                                    onPress={_handleClearSelectedDate} />
                                            }
                                        </div>
                                    </div>
                                </div>

                                {dateToggle &&
                                    <>
                                        <OverLay className="e-bg-overlay " isOpen={dateToggle} onClose={_handleDateToggle} />
                                        <CustomDatePicker selected={selectedDay}
                                            className='e-day-picker w-358px position-absolute e-bg-white e-border-radius-16 z-index-99'
                                            onSelect={_handleDayClick} />
                                    </>
                                }

                                <div className='row'>
                                    <div ref={(ref) => errorRef.current['time'] = ref} className='col-6'>
                                        <CustomTimePicker label="Set time"
                                            showSecond={false}
                                            placeholder='Choose a time'
                                            value={selectedTime}
                                            open={showTimePicker}
                                            error={timeError}
                                            handleClose={_handleShowTimePicker}
                                            handleOpen={_handleShowTimePicker}
                                            handleChange={_handleTimeChange} />
                                    </div>
                                </div>

                                <div ref={(ref) => errorRef.current['title'] = ref}>
                                    <CustomTextInput label="Title"
                                        placeholder="Message title"
                                        type="text"
                                        require
                                        value={scheduleTitle}
                                        error={scheduleTitleError}
                                        className="w-100"
                                        labelStyle="e-font-weight-500 e-text-raisin-black"
                                        handleChange={(e) => setScheduleTitle(e)} />
                                </div>

                                <div ref={(ref) => errorRef.current['content'] = ref}>
                                    <TextArea label="Content"
                                        placeholder="Enter your text..."
                                        type="text"
                                        rows="3"
                                        require
                                        value={scheduleContent}
                                        error={scheduleContentError}
                                        className=" px-3 padding-12px-tb w-100"
                                        handleChange={(e) => setScheduleContent(e)} />
                                </div>

                                <div ref={(ref) => errorRef.current['image'] = ref} >
                                    <CustomFileUpload label="Upload image"
                                        placeholder="Drop your image here"
                                        require
                                        file={scheduledImage}
                                        fileType={["JPG", "PNG", "JPEG"]}
                                        resolution="328px * 150px"
                                        requiredWidth={328}
                                        requiredHeight={150}
                                        errorUpdate={errorUpdate}
                                        error={scheduledImageError}
                                        loader={scheduledImageLoader}
                                        handleChange={_uploadedScheduledImage} />
                                    {scheduledImage !== null &&
                                        <div className='mb-2 margin-neg-20px-top'>
                                            <TextButton name="Change image"
                                                onPress={_handleChangeScheduledImage} />
                                        </div>
                                    }
                                </div>

                                <div className='e-display-flex justify-content-space-between pt-3'>
                                    <p className='mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-16 e-font-weight-400 line-height-22px'>
                                        Repeat this notification
                                    </p>
                                    <label className={`${styles.e_repeatnotification} `} >
                                        <input type="checkbox"
                                            checked={repeatToggle}
                                            onChange={_handleRepeatToggle} />
                                        <span className={`${styles.e_slider}`}></span>
                                    </label>
                                </div>
                                <div >
                                    {repeatToggle &&
                                        <div className='d-flex gap-0-10 pt-4 pb-3'>
                                            {REPEAT_TAB.map((data, key) => (
                                                <div key={key} className={`${repeatTab === data.id ? 'e-border-1px-lust cursor-default' : 'e-border-1px-platinum-light cursor-pointer'} e-text-raisin-black e-border-radius-8 r`}
                                                    onClick={() => _handleRepeatTabChange(data.id)} >
                                                    <p className='mb-0 px-4 py-2 e-alt-font-noto-sans e-font-16 e-font-weight-500 line-height-22px'>
                                                        {data.name}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className='pt-4 mt-2 pe-3'>
                                <PrimaryButton name={notificationId === null ? "Schedule & send later" : "Update scheduled & send later "}
                                    className="w-100"
                                    status={sendCreateLoader}
                                    onPress={_handleSchedulePushNotification} />
                            </div>
                        </div>
                    }

                </div>
            </div> */}

            {/*  Push notification history card */}
            <div ref={cardRef} className=''>
                <div className='d-flex justify-content-space-between'>
                    <h4 className='mb-0 e-text-dark-jungle-green e-primary-font-playfair e-font-18 e-font-weight-500 line-height-28px'>
                        Push notification history
                    </h4>

                    <img src={toggleFilter ? require("../../../../Assets/Image/filter-icon-white.svg").default : require("../../../../Assets/Image/filter-icon.svg").default}
                        draggable={false}
                        className={`${toggleFilter ? `e-bg-indigo` : ``} transition e-border-1px-cool-grey  e-border-radius-8 p-2 cursor-pointer`}
                        alt='filter'
                        onClick={() => setToggleFilter(!toggleFilter)} />
                </div>

                {/* toggle filter */}
                {toggleFilter &&
                    <div className='e-bg-anti-flash-white-dark py-3 px-4 mt-3'>
                        <div className='row'>
                            <div className='col-md-3 col-sm-4 col-6'>
                                <p className='mb-0 e-text-dark-black e-alt-font-noto-sans e-font-14 e-font-weight-600 line-height-20px'>
                                    Created date
                                </p>
                                {/* Pick date  */}
                                <div className='pt-2 row'>
                                    <div className='position-relative '>
                                        <div className={`${dateToggle ? 'e-border-1px-indigo' : 'e-border-1px-platinum-light'} e-display-flex gap-0-4px justify-content-between e-border-radius-4 p-2 cursor-pointer e-bg-white`}
                                            onClick={() => setDateToggle(!dateToggle)}>

                                            {selectedDay !== null ?
                                                <p className='mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-16px'>
                                                    {format(selectedDay, 'PP')}
                                                </p>
                                                :
                                                <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-16px'>
                                                    Choose date
                                                </p>
                                            }
                                            <div className='d-flex' onClick={(e) => e.stopPropagation()}>
                                                {selectedDay === null ?
                                                    <img src={require("../../../../Assets/Image/CountryAdmin/Notification/calendar-icon.svg").default}
                                                        draggable={false}
                                                        width={16}
                                                        height={16}
                                                        alt='calender-icon' />

                                                    :
                                                    < Icon icon="close-icon"
                                                        className='cursor-pointer d-flex'
                                                        size={16}
                                                        onPress={() => setSelectedDay(null)} />
                                                }
                                            </div>
                                        </div>

                                        {/* error message */}
                                        <p className='mb-0 e-error-message e-alt-font-noto-sans e-font-12 line-height-12px padding-2-top'>
                                            {selectedDayError}
                                        </p>


                                    </div>
                                </div>

                                {/* date picker */}
                                {dateToggle &&
                                    <>
                                        <Overlay className="e-bg-overlay " isOpen={dateToggle} onClose={() => setDateToggle(!dateToggle)} />
                                        <CustomDatePicker selected={selectedDay}
                                            className='e-day-picker w-358px position-absolute e-bg-white e-border-radius-16 z-index-99'
                                            disableFuture={true}
                                            onSelect={(day) => {
                                                setSelectedDay(day);
                                                setDateToggle(false);
                                            }} />
                                    </>
                                }
                            </div>

                            <div className='col-md-3 col-sm-4 col-6 mt-auto'>
                                <div className='d-flex gap-3 align-items-center '>
                                    <TextButton name="Clear all"
                                        onPress={_handleClearAll} />
                                    <PrimaryButton name="Filter now"
                                        className="px-3 py-1 e-border-radius-8"
                                        onPress={() => {
                                            setLoading(true);
                                            _pushNotificationHistory(1);
                                        }} />
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {loading ?
                    <Loader className="h-30vh" />  //loader
                    :
                    <>
                        {notificationHistoryData.data.length !== 0 ?
                            <div className=''>
                                {notificationHistoryData.data.map((data, key) => (
                                    <ScheduledNotifications key={key}
                                        notification={data}
                                        handleResend={() => {
                                            // _handleResendNotification(data)
                                            props.handleResend(data);
                                        }}
                                        type={1} />
                                ))}

                                {/* pagination */}
                                {totalPageCount > 1 &&
                                    <div className="d-flex justify-content-center e-gap-0-16 mt-4 pt-3">
                                        <Pagination itemsPerPage={ITEMS_PER_PAGE}
                                            totalPage={totalPageCount}
                                            showFirstLastPages={true}
                                            onChange={_handlePagination} />
                                    </div>
                                }
                            </div>
                            :
                            // empty screen 
                            <div className='min-h-30vh pt-5 mt-4'>
                                <EmptyScreen message="No history found" />
                            </div>
                        }
                    </>
                }
            </div>

            {
                showResendNotificationModal &&
                <ResendPushNotification onCloseModal={() => setShowResendNotificationModal(false)}
                    data={resendNotificationData} />
            }

        </div>
    )
}

export default memo(ConfigurePushNotification);